import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Helper estándar shadcn/ui: combina clases + resuelve conflictos Tailwind.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Retorna la fecha de hoy en timezone Chile (`America/Santiago`) en formato `YYYY-MM-DD`.
 *
 * Crítico: `new Date().toISOString().split('T')[0]` usa UTC → cambia de día a las 21:00 Chile.
 * Este helper garantiza el día correcto en cualquier runtime (server UTC, browser en cualquier TZ).
 *
 * Ver regla global timezone Chile en `~/.claude/CLAUDE.md` + `memory/gotchas-healthcare.md` gotcha #5.
 */
export function todayChile(): string {
  // 'sv-SE' locale emite YYYY-MM-DD idéntico a ISO date sin tiempo.
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Santiago' })
}

/**
 * Retorna el timestamp ISO actual en timezone Chile (con offset).
 * Útil para mostrar "hora de última actualización" al usuario sin confundir TZ.
 */
export function nowChileISO(): string {
  const fmt = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
  return fmt.format(new Date()).replace(' ', 'T')
}
